import React from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";

const DestinationSettingsSection = ({
  newQuestName,
  setNewQuestName,
}: {
  newQuestName: string;
  setNewQuestName: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_duplication.section.destination_settings")}
      rows={[
        {
          label: t("quest_duplication.field.destination.name"),
          required: true,
          children: (
            <TextField
              size="small"
              value={newQuestName}
              onChange={(e) => setNewQuestName(e.target.value)}
              sx={{ minWidth: 400 }}
            />
          ),
        },
      ]}
    />
  );
};

export default DestinationSettingsSection;
